import Modal from '@helios/Modal'
import PhotoMosaic from '@helios/PhotoMosaic'

import {
  GALLERY_LABELS,
  GALLERY_TILE_SIZES,
  galleryMosaicItems,
} from '@/content/galleryPeople.js'
import LeadForm from './LeadForm.js'
import styles from './RequestInfoModal.module.scss'

function RequestInfoModal({close, site}) {
  const content = (
    <div
      className={`${styles['request-info-modal']} ${styles['control-modal-grid']}`}
    >
      <div className={styles['control-modal-column']}>
        <div className={styles['control-gallery']}>
          <PhotoMosaic
            layout="frame"
            items={galleryMosaicItems('studentsInfo')}
            label={GALLERY_LABELS.studentsInfo}
            nameAs="h6"
            sizes={GALLERY_TILE_SIZES.modal}
          />
        </div>
        <div className={styles['modal-copy']}>
          <div className={styles['modal-logo']}>Campus</div>
          <Modal.Title>Connect with Admissions.</Modal.Title>
          <p className={styles['modal-description']}>
            Provide your information and an admissions counselor will be in
            touch shortly (typically within 24 hours).
          </p>
        </div>
      </div>
      <div className={styles['control-modal-column']}>
        <LeadForm site={site} onClose={close} />
      </div>
    </div>
  )

  return (
    <Modal
      ariaLabel="Connect with Admissions."
      backdrop="default"
      open
      onClose={close}
      radius="default"
      size="lg"
    >
      <Modal.Body padding="none">{content}</Modal.Body>
    </Modal>
  )
}

export default RequestInfoModal
